import apiClient from "./config";
import { JOB_ENDPOINTS } from "./endpoints";

export const getJobApplicationList = () => apiClient.get(JOB_ENDPOINTS.GET_APPLICATION_LIST);

